import { TwilioAccountService } from '../../../services'

const fetchAgencyTwilio = async function ({ commit }, config) {
  const { companyId } = config

  try {
    const res = await TwilioAccountService.getAgencyTwilio(companyId)

    commit('setAgencyTwilio', res)
    return Promise.resolve(res)
  } catch (error: any) {
    commit('clearAgencyTwilio')
    return Promise.reject(error)
  }
}

export default fetchAgencyTwilio
